const deleteUser = (username) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
  
    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };
  
    return fetch(
      `${process.env.REACT_APP_API_URL}/delete_user?username=${username}`,
      requestOptions
    )
      .then((response) => {
        return response.status;
      })
      .catch((error) => {throw new Error(error)});
  };
  
  export default deleteUser;
  